import api from '../api';
import { Failure } from '../../entities/Failure';
import { Success } from '../../entities/Success';
import * as yup from 'yup';

/**
 * @typedef {Object} Props
 * @property {number} companyContractNumber,
 * @property {string[]} mountingsIds,
 * @property {string[]} productsIds,
 */

/**
 * @param {Props} props
 * @returns {Promise<Success | Failure>}
 */
export async function createProductMountingBatch(props) {
  try {
    const validated = createProductMountingBatchSchema.validateSync(props);

    const { data } = await api.post(`/produto-montagens/criar-lote`, {
      companyContractNumber: validated.companyContractNumber,
      mountingsIds: validated.mountingsIds,
      productsIds: validated.productsIds,
    });
    
    return new Success(data);
  } catch (error) {
    let errorMessage = '';

    if (error instanceof yup.ValidationError) {
      console.error(error.message);
      errorMessage = error.message;
    }

    console.error('[createProductMountingBatch] ERROR: ', error);

    return new Failure(errorMessage);
  }
}

const createProductMountingBatchSchema = yup.object({
  companyContractNumber: yup.number().required(),
  mountingsIds: yup.array().of(yup.string().required()).required(),
  productsIds: yup.array().of(yup.string().required()).required(),
});
